import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m11.473 5.446-6.925 6.925a.5.5 0 0 0-.146.354v1.65a.5.5 0 0 0 .5.5h1.65a.5.5 0 0 0 .353-.147l6.925-6.925m-2.357-2.357 2.592-2.592a.5.5 0 0 1 .708 0l1.65 1.65a.5.5 0 0 1 0 .707L13.83 7.803m-2.357-2.357 2.357 2.357"
    }, null, -1)
  ]))]))
}
export default { render: render }